import { useState } from 'react';
import './Riddle.css';

const riddles = {
    1: {q: 'What 5-letter word typed in all capital letters can be read the same upside down?', a: 'swims'},
    2: {q: 'The more you take, the more you leave behind. What am I?', a: 'footsteps'},
    3: {q: 'David\'s father has three sons: Snap, Crackle, and _____?', a: 'david'},
    4: {q: 'What is more useful when it is broken?', a: 'egg'},
    5: {q: 'I am easy to lift, but hard to throw. What am I?', a: 'feather'},
    6: {q: 'Which fish costs the most?', a: 'goldfish'},
    7: {q: 'What goes up, but never comes down?', a: 'age'},
    8: {q: 'What has a neck but no head?', a: 'bottle'},
    9: {q: 'What is full of holes but still holds water?', a: 'sponge'},
    10: {q: 'If 2 is company and 3 is a crowd, what are 4 and 5?', a: '9'},
    11: {q: 'Rachel goes to the supermarket and buys 10 tomatoes. Unfortunately, on the way back home, all but 9 get ruined. How many tomatoes are left in a good condition?', a: '9'},
    12: {q: 'What is 3/7 chicken, 2/3 cat, and 2/4 goat?', a: 'chicago'},
    13: {q: 'I am an odd number. Take away a letter and I become even. What number am I?', a: '7'},
    14: {q: 'Pronounced as 1 letter, And written with 3, 2 letters there are, and 2 only in me. I\'m double, I\'m single, I\'m black blue, and gray, I\'m read from both ends, and the same either way. What am I?', a: 'eye'},
    15: {q: 'Forward, I am heavy; backward, I am not. What am I?', a: 'ton'},
    16: {q: 'What can you hold in your right hand, but never in your left hand?', a: 'left hand'},
    17: {q: 'I have a head like a cat and feet like a cat, but I am not a cat. What am I?', a: 'kitten'},
    18: {q: 'Who makes it, has no need of it. Who buys it, has no use for it. Who uses it can neither see nor feel it. What is it?', a: 'coffin'},
    19: {q: 'What gets broken without being held?', a: 'promise'},
    20: {q: 'Poor people have it. Rich people need it. If you eat it you die. What is it?', a: 'nothing'}
}


const RiddleComponent = () => {
    const [riddle, setRiddle] = useState(1);
    const [answer, setAnswer] = useState('');
    const [message, setMessage] = useState('');
    
    const handleSubmit = () => {
        const riddleAnswer = riddles[riddle].a;
        const holdAnswer = answer;
        
        if (!answer) return setMessage('You must type something.');
        
        setAnswer('');
        
        if (riddleAnswer.toLowerCase() === holdAnswer.toLowerCase()) {
            setMessage('That is correct! Way to go, here is another one.');
            return nextRiddle();
        };
        
        setMessage('Sorry, that is not correct. Try again.');
    };
    
    const nextRiddle = () => {
        if (riddle + 1 > 20) return setRiddle(1);
        return setRiddle(riddle + 1);
    }
    
    return (
        <div id='riddle-container'>
            <h2>Riddles</h2>
            <p id='riddle-question'>{riddles[riddle].q}</p>
            <p id='riddle-message'>{message}</p>
            
            <div id='riddle-input-div'>
                <input type='text' id='riddle-guess-input'
                    value={answer}
                    onChange={(e) => setAnswer(e.target.value)}
                /><br></br>
                
                <button className='riddle-guess-button'
                    onClick={handleSubmit}
                >Submit</button>
                
                <button className='riddle-guess-button'
                    onClick={nextRiddle}
                >Skip</button>
            </div>
            
        </div>
    );
};

export default RiddleComponent;
